/* eslint-disable */
// UFA11 V2 — extension dictionary: keys for strings that have no existing key
// in the shared i18n dictionary. Merged into ./i18n as a side-effect.
import translations from './i18n';

const ext = {
  th: {
    ufa_casino_online:    'คาสิโนออนไลน์',
    ufa_football_online:  'แทงบอลออนไลน์',
    ufa_review_service:   'รีวิวบริการ',
    ufa_make_income:      'สร้างรายได้',
    ufa_contact_us:       'ติดต่อเรา',
    ufa_login_member:     'เข้าสู่ระบบสมาชิก',
    ufa_login_with_line:  'เข้าสู่ระบบด้วย LINE',
    ufa_phone_label:      'เบอร์โทรศัพท์',
    ufa_phone_placeholder:'เบอร์โทร',
    ufa_phone_placeholder_full: 'กรอกเบอร์โทรศัพท์',
    ufa_password_placeholder:   'กรอกรหัสผ่าน',
    ufa_alert:            'แจ้งเตือน',
    ufa_login_before_action: 'กรุณาเข้าสู่ระบบก่อนทำรายการ',

    ufa_create_deposit_title:    'สร้างรายการฝาก',
    ufa_create_deposit_subtitle: 'เลือกช่องทางและระบุจำนวนเงินที่ต้องการฝาก',
    ufa_deposit_channel:         'ช่องทางฝาก',
    ufa_bank_account:            'บัญชีธนาคาร',
    ufa_confirm_amount:          'ยืนยันจำนวนเงิน',
    ufa_cannot_create_deposit:   'ไม่สามารถสร้างรายการฝากได้',
    ufa_confirm_topup:           'ยืนยันการเติมเงิน',
    ufa_cancel_qr_title:         'ยกเลิก QR code',
    ufa_cancel_qr_text:          'คุณต้องการยกเลิกการใช้ Qr code',
    ufa_complete_within_time:    'กรุณาทำรายการภายในเวลา',
    ufa_amount_to_transfer:      'ยอดเงินที่ต้องโอน',
    ufa_deposit_timeout:         'รายการฝากหมดเวลาแล้ว กรุณาสร้างรายการใหม่',
    ufa_account_copied_notice:   'คัดลอกเลขบัญชีแล้ว หน้านี้จะค้างไว้จนกว่ารายการฝากจะหมดเวลา',
    ufa_invalid_deposit_amount:  'ยอดฝากไม่ถูกต้อง',
    ufa_pending_deposit_title:   'มีรายการฝากค้างอยู่',
    ufa_old_order:               'รายการเดิม',
    ufa_new_amount:              'ยอดใหม่',
    ufa_cancel_old_create_new:   'ต้องการยกเลิกรายการเดิม แล้วสร้างรายการใหม่หรือไม่?',
    ufa_create_new_order:        'สร้างรายการใหม่',
    ufa_use_old_order:           'ใช้รายการเดิม',
    ufa_deposit_closed_temp:     'ปิดรับฝากชั่วคราว',
    ufa_gateway_closed_temp:     'ช่องทาง Payment Gateway ปิดให้บริการชั่วคราว',
    ufa_no_payment_channel:      'ไม่พบช่องทางชำระเงิน',
    ufa_no_link_or_qr:           'ไม่พบลิงก์หรือ QR Code สำหรับ Payment Gateway',
    ufa_no_bank_for_deposit:     'ไม่พบบัญชีธนาคารสำหรับทำรายการฝาก',
    ufa_no_password:             'คุณไม่ได้ใส่รหัสผ่าน',
    ufa_password_more_6:         'โปรดใส่รหัสผ่านมากกว่า 6 ตัว',
    ufa_fill_bank_info_6:        'กรุณาเลือกธนาคาร หรือใส่ข้อมูลให้ครบถ้วน',
    ufa_please_wait:             'กรุณารอ',
    ufa_promo_received:          'รับโปรโมชั่นเรียบร้อย โปรดทำการเติมเงิน',
    ufa_promo_pending:           'ท่านมีการรับโปรโมชั่นค้างไว้',
    ufa_withdraw_bonus_line1:    'ต้องการถอนโบนัสจำนวน 0 เครดิต ใช่หรือไม่?',
    ufa_withdraw_bonus_line2:    'คุณจะได้รับเครดิตคืนจาก (สล็อต: 0 คาสิโนสด: 0 กีฬา: 0)',
    ufa_confirm_withdraw_bonus:  'ยืนยันการถอนโบนัส',
    ufa_your_member_id:          'รหัสสมาชิกของคุณคือ',
    ufa_hello:                   'สวัสดี',
    ufa_your_credit_balance:     'ยอดเครดิตของคุณ',
    ufa_finance_history:         'ประวัติการเงิน',
    ufa_rank_system:             'ระบบ Rank',
    ufa_open_card_fortune:       'เปิดไพ่เสี่ยงโชค',
    ufa_spin_fortune_wheel:      'หมุนกงล้อเสี่ยงโชค',
    ufa_coupon:                  'คูปอง',
    ufa_get_cashback_credit:     'รับเครดิตเงินคืน',
    ufa_contact_staff:           'ติดต่อเจ้าหน้าที่',
    ufa_play_entrance:           'ทางเข้าเล่น UFA11',
    ufa_backup:                  'สำรอง',
    ufa_game_user:               'User เข้าเกมส์',
    ufa_balance_remaining:       'ยอดเงินคงเหลือ',
    ufa_pwd_hint_1:              '*รหัสผ่านของท่านต้องประกอบด้วยตัวอักษร 8-15 ตัว',
    ufa_pwd_hint_2:              '*รหัสผ่านของคุณจะต้องมีการรวมกันของตัวอักษรตัวเลขและสัญลักษณ์',
    ufa_pwd_hint_3:              '*ห้ามใช้ชื่อเข้าระบบ ชื่อจริงและนามสกุลเป็นส่วนหนึ่งของรหัสผ่าน',
    ufa_play_now:                'เล่นเดี๋ยวนี้',
    ufa_total_all:               'รวมทั้งหมด',
    ufa_processing:              'กำลังดำเนินการ',
    ufa_failed:                  'ไม่สำเร็จ',
    ufa_item:                    'รายการ',
    ufa_credit_refund:           'คืนเครดิต',
    ufa_update_pwd_ufa:          'update Password UFA ในระบบ:',
    ufa_referral_link_label:     'Link แนะนำ',
    ufa_copy_link:               'คัดลอก link',
    ufa_referred_friends_count:  'จำนวนเพื่อนที่แนะนำ',
    ufa_referral_credit_count:   'จำนวนเครดิตแนะนำ',
    ufa_transfer_to_credit:      'โอนเงินเข้าเครดิต',
    ufa_min_500_transfer:        '*ยอดขั้นต่ำ 500 บาท จึงจะโอนเข้าเครดิตได้',
    ufa_your_income:             'รายได้ของท่าน',
    ufa_share_via_line:          'แนะนำผ่าน LINE',
    ufa_share_via_messenger:     'แนะนำผ่าน Messenger',
    ufa_share_via_facebook:      'แนะนำผ่าน Facebook',
    ufa_cashback_amount:         'จำนวนเงินคืน',
    ufa_min_15_transfer:         '*ยอดขั้นต่ำ 15 บาท จึงจะโอนเข้าเครดิตได้',
    ufa_balance_baht:            'ยอดเงินคงเหลือ (บาท)',
    ufa_finish_deposit_first:    'กรุณาทำรายการฝากเงินให้เสร็จสิ้นก่อนสร้างรายการใหม่',
    ufa_need_help_contact_line:  'หากต้องการความช่วยเหลือ ติดต่อแอดมิน LINE:',
    ufa_continue_transaction:    'ทำรายการต่อ',
    ufa_create_new_deposit:      'สร้างรายการฝากใหม่',
    ufa_deposit_registered_only: 'กรุณาฝากด้วยบัญชีที่ลงทะเบียนไว้เท่านั้น',
    ufa_deposit_problem_contact: 'หากไม่สามารถทำรายการฝากเงินได้ ติดต่อแอดมินได้ตลอด 24 ชั่วโมง ที่',
    ufa_view_deposit_history:    'ดูประวัติฝากเงิน',
    ufa_transfer_to_bank:        'โอนเข้าธนาคาร',
    ufa_amount:                  'จำนวนเงิน',
    ufa_withdraw_placeholder:    '300 หรือ 5000 ไม่ต้องใส่ , (ลูกน้ำ)!',
    ufa_notify_withdraw:         'แจ้งถอนเงิน',
    ufa_bank_maintenance_notice: 'ระบบธนาคารจะปิดปรับปรุงประจำวันในช่วงเวลา 23.00น. - 00.00น. และ 01.00น.- 02.00น. แต่ลูกค้ายังสามารถทำการถอนเงินออกได้ปกติ ลูกค้าที่ถอนเงินออกมาในช่วงเวลาดังกล่าวยอดถอนของท่านอาจจะล่าช้ากว่าปกติ ขออภัยในความไม่สะดวก',
    ufa_invite_earn:             'แนะนำเพื่อนสร้างรายได้',
    ufa_opencard_title:          'เปิดไพ่รับเงินแจกวันละ 5,000,000 บาท',
    ufa_join_conditions:         'เงื่อนไขการร่วมสนุก',
    ufa_card_rule_1:             'ต้องมียอดฝากแรกของวันขั้นต่ำ 100 บาท (ถึงจะเล่นไพ่เสี่ยงโชคได้)',
    ufa_card_rule_2:             'ต้องมีรายการเล่นของวันนั้นแล้วอย่างน้อย 5 รายการเล่น',
    ufa_card_rule_3:             'เล่นได้วันละครั้งเท่านั้น..ปิดระบบ 00.00-11.00 ของทุกวัน',
    ufa_card_rule_4:             'รายการเล่น..รี หลัง 11.00 ของทุกวัน',
    ufa_card_rule_5:             'แจกวันละ 3,000 user เท่านั้น! รับได้อีกทีหลังเวลารีระบบ',
    ufa_card_rule_6:             'ต้องมีเงินคงเหลือไม่ต่ำกว่า 100 บาท',
    ufa_card_rule_7:             'หลังจากเปิดไพ่นำโชคแล้วจะต้องทำเทิร์น 4 เท่าของโบนัสที่เปิดได้ ถึงจะถอนเงินได้',
    ufa_start_opencard_cta:      'เริ่มเปิดไพ่เสี่ยงโชค คลิกที่นี่!',
    ufa_wheel_rule_1:            'ต้องมียอดเสียของวันนั้น 1,000 บาท ถึงจะรับสิทธิปั่นกงล้อในวันนั้นได้ 1 ครั้ง',
    ufa_wheel_rule_2:            'เมื่อรับโบนัสเกมกงล้อ จะต้องทำ turnover 4 เท่าของโบนัสที่เปิดได้ ถึงจะถอนเงินได้',
    ufa_wheel_rule_3:            'แจกทุก user ไม่อั้น ทุกวัน ไม่มีจำกัด',
    ufa_wheel_rule_4:            'ท่านที่ได้รับทอง 1 บาท ให้แจ้งทีมงานทันที (ทีมงานจะสอบถามและส่งรางวัลให้ถึงที่)',
    ufa_wheel_rule_5:            'เล่นได้วันละครั้งเท่านั้น..ปิดระบบ 00.00-11.00 ของทุกวัน',
    ufa_wheel_rule_6:            'นับรายการเล่นช่วง 11.00-23.59น. เท่านั้น',
    ufa_wheel_rule_7:            '(ยิ่งมียอดเสียเยอะก็ยิ่งลุ้นรับรางวัลใหญ่ได้เยอะขึ้น)',
    ufa_wheel_warning:           'หากพบเห็นตั้งใจแทงสวนหรือปั้มโบนัส..มากกว่า 1 user จะทำการยึดเงินทันทีไม่มีคืนเงิน เด็ดขาด!',
    ufa_start_wheel_cta:         'เริ่มหมุนกงล้อเสี่ยงโชค คลิกที่นี่!',
    ufa_checkin_rule_1:          'ต้องมียอดฝากแรกของวันขั้นต่ำ 100 บาท (ถึงจะเช็คอินได้)',
    ufa_checkin_rule_2:          'ต้องมีรายการเล่นของวันนั้นแล้วอย่างน้อย 1 รายการเล่น',
    ufa_checkin_rule_3:          'เล่นได้วันละครั้งเท่านั้น..ปิดระบบ 00.00-23.00 ของทุกวัน',
    ufa_checkin_rule_4:          'รายการเล่น..รี หลัง 23.00 ของทุกวัน',
    ufa_checkin_rule_5:          'แจกทุกวัน รับได้หลังเวลารีระบบ',
    ufa_checkin_rule_6:          'ต้องมีเงินคงเหลือไม่ต่ำกว่า 100 บาท',
    ufa_checkin_rule_7:          'หลังจากเช็คอินแล้วจะต้องทำเทิร์น 4 เท่าของโบนัสที่เปิดได้ ถึงจะถอนเงินได้',
    ufa_start_checkin_cta:       'เริ่มเช็คอิน คลิกที่นี่!',
    ufa_customer_reviews:        'รีวิวคำชมจากลูกค้า',
    ufa_real_reviews:            'รีวิวจากลูกค้าจริง',
    ufa_total:                   'ทั้งหมด',
    ufa_reviews_unit:            'รีวิว',
    ufa_loading_reviews:         'กำลังโหลดรีวิว...',
    ufa_no_reviews:              'ยังไม่มีรีวิว',
    ufa_no_comment:              'ไม่มีความคิดเห็น',
    ufa_rank_subtitle:           'สะสมคะแนนเพื่อรับรางวัล Rank พิเศษ',
    ufa_current_rank:            'Rank ปัจจุบัน',
    ufa_accumulated_points:      'คะแนนสะสม',
    ufa_login_to_view_rank:      'กรุณาเข้าสู่ระบบเพื่อดูและรับ Rank ของคุณ',
    ufa_points_up:               'แต้มขึ้นไป',
    ufa_get_bonus:               'รับโบนัส',
    ufa_claimed:                 'รับแล้ว',
    ufa_claim:                   'กดรับ',
    ufa_not_reached:             'ยังไม่ถึง',
    ufa_no_rank_data:            'ยังไม่มีข้อมูล Rank ในระบบ',
    ufa_betting_hub_tagline:     'ศูนย์รวมเว็บพนันออนไลน์ ที่ยิ่งใหญ่ที่สุดในประเทศ',
  },
  en: {
    ufa_casino_online:    'Online Casino',
    ufa_football_online:  'Sports Betting',
    ufa_review_service:   'Service Reviews',
    ufa_make_income:      'Earn Income',
    ufa_contact_us:       'Contact Us',
    ufa_login_member:     'Member Login',
    ufa_login_with_line:  'Login with LINE',
    ufa_phone_label:      'Phone Number',
    ufa_phone_placeholder:'Phone',
    ufa_phone_placeholder_full: 'Enter phone number',
    ufa_password_placeholder:   'Enter password',
    ufa_alert:            'Notice',
    ufa_login_before_action: 'Please log in before making a transaction',

    ufa_create_deposit_title:    'Create Deposit',
    ufa_create_deposit_subtitle: 'Select a channel and enter the amount to deposit',
    ufa_deposit_channel:         'Deposit Channel',
    ufa_bank_account:            'Bank Account',
    ufa_confirm_amount:          'Confirm Amount',
    ufa_cannot_create_deposit:   'Unable to create deposit',
    ufa_confirm_topup:           'Confirm Top-up',
    ufa_cancel_qr_title:         'Cancel QR code',
    ufa_cancel_qr_text:          'Do you want to cancel this QR code?',
    ufa_complete_within_time:    'Please complete within the time limit',
    ufa_amount_to_transfer:      'Amount to Transfer',
    ufa_deposit_timeout:         'The deposit has timed out. Please create a new one',
    ufa_account_copied_notice:   'Account number copied. This page will stay open until the deposit expires',
    ufa_invalid_deposit_amount:  'Invalid deposit amount',
    ufa_pending_deposit_title:   'You have a pending deposit',
    ufa_old_order:               'Previous order',
    ufa_new_amount:              'New amount',
    ufa_cancel_old_create_new:   'Cancel the previous order and create a new one?',
    ufa_create_new_order:        'Create New Order',
    ufa_use_old_order:           'Use Previous Order',
    ufa_deposit_closed_temp:     'Deposits temporarily closed',
    ufa_gateway_closed_temp:     'The Payment Gateway is temporarily unavailable',
    ufa_no_payment_channel:      'No payment channel found',
    ufa_no_link_or_qr:           'No link or QR Code found for Payment Gateway',
    ufa_no_bank_for_deposit:     'No bank account available for deposit',
    ufa_no_password:             'You did not enter a password',
    ufa_password_more_6:         'Please enter a password longer than 6 characters',
    ufa_fill_bank_info_6:        'Please select a bank or complete the information',
    ufa_please_wait:             'Please wait',
    ufa_promo_received:          'Promotion received. Please make a deposit',
    ufa_promo_pending:           'You have a pending promotion',
    ufa_withdraw_bonus_line1:    'Do you want to withdraw a bonus of 0 credits?',
    ufa_withdraw_bonus_line2:    'You will receive credit back from (Slots: 0 Live Casino: 0 Sports: 0)',
    ufa_confirm_withdraw_bonus:  'Confirm Bonus Withdrawal',
    ufa_your_member_id:          'Your member ID is',
    ufa_hello:                   'Hello',
    ufa_your_credit_balance:     'Your Credit Balance',
    ufa_finance_history:         'Transaction History',
    ufa_rank_system:             'Rank System',
    ufa_open_card_fortune:       'Lucky Card Draw',
    ufa_spin_fortune_wheel:      'Spin the Lucky Wheel',
    ufa_coupon:                  'Coupon',
    ufa_get_cashback_credit:     'Claim Cashback Credit',
    ufa_contact_staff:           'Contact Staff',
    ufa_play_entrance:           'Play UFA11',
    ufa_backup:                  'Backup',
    ufa_game_user:               'Game Username',
    ufa_balance_remaining:       'Available Balance',
    ufa_pwd_hint_1:              '*Your password must be 8-15 characters long',
    ufa_pwd_hint_2:              '*Your password must contain a mix of letters, numbers and symbols',
    ufa_pwd_hint_3:              '*Do not use your login name, first name or last name as part of the password',
    ufa_play_now:                'Play Now',
    ufa_total_all:               'Total',
    ufa_processing:              'Processing',
    ufa_failed:                  'Failed',
    ufa_item:                    'Item',
    ufa_credit_refund:           'Credit Refund',
    ufa_update_pwd_ufa:          'Update Password UFA in system:',
    ufa_referral_link_label:     'Referral Link',
    ufa_copy_link:               'Copy link',
    ufa_referred_friends_count:  'Number of Referred Friends',
    ufa_referral_credit_count:   'Referral Credit',
    ufa_transfer_to_credit:      'Transfer to Credit',
    ufa_min_500_transfer:        '*Minimum 500 THB required to transfer to credit',
    ufa_your_income:             'Your Income',
    ufa_share_via_line:          'Share via LINE',
    ufa_share_via_messenger:     'Share via Messenger',
    ufa_share_via_facebook:      'Share via Facebook',
    ufa_cashback_amount:         'Cashback Amount',
    ufa_min_15_transfer:         '*Minimum 15 THB required to transfer to credit',
    ufa_balance_baht:            'Available Balance (THB)',
    ufa_finish_deposit_first:    'Please complete your deposit before creating a new one',
    ufa_need_help_contact_line:  'Need help? Contact admin on LINE:',
    ufa_continue_transaction:    'Continue',
    ufa_create_new_deposit:      'Create New Deposit',
    ufa_deposit_registered_only: 'Please deposit only from your registered account',
    ufa_deposit_problem_contact: 'If you cannot make a deposit, contact admin 24 hours at',
    ufa_view_deposit_history:    'View Deposit History',
    ufa_transfer_to_bank:        'Transfer to Bank',
    ufa_amount:                  'Amount',
    ufa_withdraw_placeholder:    '300 or 5000, no commas!',
    ufa_notify_withdraw:         'Withdraw',
    ufa_bank_maintenance_notice: 'The banking system undergoes daily maintenance from 23:00-00:00 and 01:00-02:00. You can still withdraw normally, but withdrawals during these times may be delayed. We apologize for any inconvenience.',
    ufa_invite_earn:             'Refer Friends & Earn',
    ufa_opencard_title:          'Draw Cards for a Daily 5,000,000 THB Prize',
    ufa_join_conditions:         'Participation Conditions',
    ufa_card_rule_1:             'Must have a first deposit of at least 100 THB today (to play the lucky card)',
    ufa_card_rule_2:             'Must have at least 5 plays today',
    ufa_card_rule_3:             'Once per day only.. system closed 00:00-11:00 daily',
    ufa_card_rule_4:             'Play records reset after 11:00 daily',
    ufa_card_rule_5:             'Limited to 3,000 users per day! Available again after system reset',
    ufa_card_rule_6:             'Must have a balance of at least 100 THB',
    ufa_card_rule_7:             'After drawing, you must wager 4x the bonus before withdrawal',
    ufa_start_opencard_cta:      'Start drawing cards, click here!',
    ufa_wheel_rule_1:            'Must have a daily loss of 1,000 THB to earn one spin that day',
    ufa_wheel_rule_2:            'When receiving the wheel bonus, you must wager 4x the bonus before withdrawal',
    ufa_wheel_rule_3:            'Given to all users, unlimited, every day',
    ufa_wheel_rule_4:            'If you win 1 baht of gold, notify the team immediately (the team will verify and deliver the prize)',
    ufa_wheel_rule_5:            'Once per day only.. system closed 00:00-11:00 daily',
    ufa_wheel_rule_6:            'Plays counted only between 11:00-23:59',
    ufa_wheel_rule_7:            '(The higher your loss, the bigger the prizes you can win)',
    ufa_wheel_warning:           'If intentional hedging or bonus farming across more than 1 user is found, funds will be seized immediately with no refund!',
    ufa_start_wheel_cta:         'Start spinning the wheel, click here!',
    ufa_checkin_rule_1:          'Must have a first deposit of at least 100 THB today (to check in)',
    ufa_checkin_rule_2:          'Must have at least 1 play today',
    ufa_checkin_rule_3:          'Once per day only.. system closed 00:00-23:00 daily',
    ufa_checkin_rule_4:          'Play records reset after 23:00 daily',
    ufa_checkin_rule_5:          'Given daily, available after system reset',
    ufa_checkin_rule_6:          'Must have a balance of at least 100 THB',
    ufa_checkin_rule_7:          'After check-in, you must wager 4x the bonus before withdrawal',
    ufa_start_checkin_cta:       'Start checking in, click here!',
    ufa_customer_reviews:        'Customer Reviews',
    ufa_real_reviews:            'Reviews from real customers',
    ufa_total:                   'Total',
    ufa_reviews_unit:            'reviews',
    ufa_loading_reviews:         'Loading reviews...',
    ufa_no_reviews:              'No reviews yet',
    ufa_no_comment:              'No comment',
    ufa_rank_subtitle:           'Collect points to earn special Rank rewards',
    ufa_current_rank:            'Current Rank',
    ufa_accumulated_points:      'Accumulated Points',
    ufa_login_to_view_rank:      'Please log in to view and claim your Rank',
    ufa_points_up:               'points and up',
    ufa_get_bonus:               'Get Bonus',
    ufa_claimed:                 'Claimed',
    ufa_claim:                   'Claim',
    ufa_not_reached:             'Not reached',
    ufa_no_rank_data:            'No Rank data in the system yet',
    ufa_betting_hub_tagline:     'The biggest online betting hub in the country',
  },
  zh: {
    ufa_casino_online:    '在线娱乐场',
    ufa_football_online:  '体育投注',
    ufa_review_service:   '服务评价',
    ufa_make_income:      '赚取收入',
    ufa_contact_us:       '联系我们',
    ufa_login_member:     '会员登录',
    ufa_login_with_line:  '使用 LINE 登录',
    ufa_phone_label:      '电话号码',
    ufa_phone_placeholder:'电话',
    ufa_phone_placeholder_full: '请输入电话号码',
    ufa_password_placeholder:   '请输入密码',
    ufa_alert:            '提示',
    ufa_login_before_action: '请先登录后再进行交易',

    ufa_create_deposit_title:    '创建存款',
    ufa_create_deposit_subtitle: '选择渠道并输入要存入的金额',
    ufa_deposit_channel:         '存款渠道',
    ufa_bank_account:            '银行账户',
    ufa_confirm_amount:          '确认金额',
    ufa_cannot_create_deposit:   '无法创建存款',
    ufa_confirm_topup:           '确认充值',
    ufa_cancel_qr_title:         '取消二维码',
    ufa_cancel_qr_text:          '您要取消使用此二维码吗？',
    ufa_complete_within_time:    '请在规定时间内完成交易',
    ufa_amount_to_transfer:      '需转账金额',
    ufa_deposit_timeout:         '存款已超时，请重新创建',
    ufa_account_copied_notice:   '已复制账号，此页面将保留至存款超时',
    ufa_invalid_deposit_amount:  '存款金额无效',
    ufa_pending_deposit_title:   '您有一笔待处理的存款',
    ufa_old_order:               '原订单',
    ufa_new_amount:              '新金额',
    ufa_cancel_old_create_new:   '要取消原订单并创建新订单吗？',
    ufa_create_new_order:        '创建新订单',
    ufa_use_old_order:           '使用原订单',
    ufa_deposit_closed_temp:     '暂停存款',
    ufa_gateway_closed_temp:     'Payment Gateway 渠道暂停服务',
    ufa_no_payment_channel:      '未找到支付渠道',
    ufa_no_link_or_qr:           '未找到 Payment Gateway 的链接或二维码',
    ufa_no_bank_for_deposit:     '未找到可用于存款的银行账户',
    ufa_no_password:             '您未输入密码',
    ufa_password_more_6:         '请输入超过6个字符的密码',
    ufa_fill_bank_info_6:        '请选择银行或填写完整信息',
    ufa_please_wait:             '请等待',
    ufa_promo_received:          '已领取优惠，请进行充值',
    ufa_promo_pending:           '您有一项待处理的优惠',
    ufa_withdraw_bonus_line1:    '您要提取0信用额度的奖金吗？',
    ufa_withdraw_bonus_line2:    '您将从以下获得返还信用（老虎机：0 真人娱乐场：0 体育：0）',
    ufa_confirm_withdraw_bonus:  '确认提取奖金',
    ufa_your_member_id:          '您的会员ID是',
    ufa_hello:                   '你好',
    ufa_your_credit_balance:     '您的信用余额',
    ufa_finance_history:         '财务记录',
    ufa_rank_system:             'Rank 等级系统',
    ufa_open_card_fortune:       '幸运翻牌',
    ufa_spin_fortune_wheel:      '转动幸运转盘',
    ufa_coupon:                  '优惠券',
    ufa_get_cashback_credit:     '领取返现信用',
    ufa_contact_staff:           '联系客服',
    ufa_play_entrance:           '进入 UFA11',
    ufa_backup:                  '备用',
    ufa_game_user:               '游戏用户名',
    ufa_balance_remaining:       '可用余额',
    ufa_pwd_hint_1:              '*您的密码必须为8-15个字符',
    ufa_pwd_hint_2:              '*您的密码必须包含字母、数字和符号的组合',
    ufa_pwd_hint_3:              '*请勿将登录名、真实姓名和姓氏用作密码的一部分',
    ufa_play_now:                '立即游玩',
    ufa_total_all:               '总计',
    ufa_processing:              '处理中',
    ufa_failed:                  '未成功',
    ufa_item:                    '项目',
    ufa_credit_refund:           '返还信用',
    ufa_update_pwd_ufa:          '更新系统中的 UFA 密码：',
    ufa_referral_link_label:     '推荐链接',
    ufa_copy_link:               '复制链接',
    ufa_referred_friends_count:  '推荐好友数量',
    ufa_referral_credit_count:   '推荐信用额度',
    ufa_transfer_to_credit:      '转入信用',
    ufa_min_500_transfer:        '*最低500泰铢方可转入信用',
    ufa_your_income:             '您的收入',
    ufa_share_via_line:          '通过 LINE 推荐',
    ufa_share_via_messenger:     '通过 Messenger 推荐',
    ufa_share_via_facebook:      '通过 Facebook 推荐',
    ufa_cashback_amount:         '返现金额',
    ufa_min_15_transfer:         '*最低15泰铢方可转入信用',
    ufa_balance_baht:            '可用余额（泰铢）',
    ufa_finish_deposit_first:    '请先完成存款再创建新订单',
    ufa_need_help_contact_line:  '需要帮助？联系 LINE 管理员：',
    ufa_continue_transaction:    '继续交易',
    ufa_create_new_deposit:      '创建新存款',
    ufa_deposit_registered_only: '请仅使用已注册的账户存款',
    ufa_deposit_problem_contact: '如无法存款，请24小时联系管理员，',
    ufa_view_deposit_history:    '查看存款记录',
    ufa_transfer_to_bank:        '转入银行',
    ufa_amount:                  '金额',
    ufa_withdraw_placeholder:    '300 或 5000，无需输入逗号！',
    ufa_notify_withdraw:         '提款',
    ufa_bank_maintenance_notice: '银行系统每日23:00-00:00及01:00-02:00进行维护。客户仍可正常提款，但此时段的提款可能会延迟。给您带来不便，敬请谅解。',
    ufa_invite_earn:             '推荐好友赚收入',
    ufa_opencard_title:          '翻牌赢取每日500万泰铢大奖',
    ufa_join_conditions:         '参与条件',
    ufa_card_rule_1:             '当日首存至少100泰铢（才能玩幸运翻牌）',
    ufa_card_rule_2:             '当日至少有5笔投注记录',
    ufa_card_rule_3:             '每日仅限一次..系统每日00:00-11:00关闭',
    ufa_card_rule_4:             '投注记录于每日11:00后重置',
    ufa_card_rule_5:             '每日仅限3,000名用户！系统重置后可再次领取',
    ufa_card_rule_6:             '余额不得低于100泰铢',
    ufa_card_rule_7:             '翻牌后须完成奖金4倍流水方可提款',
    ufa_start_opencard_cta:      '开始翻牌，点击这里！',
    ufa_wheel_rule_1:            '当日须有1,000泰铢亏损方可获得当日1次转盘机会',
    ufa_wheel_rule_2:            '领取转盘奖金后，须完成奖金4倍流水方可提款',
    ufa_wheel_rule_3:            '所有用户每日无限量赠送',
    ufa_wheel_rule_4:            '如赢得1泰铢黄金，请立即通知团队（团队将核实并送达奖品）',
    ufa_wheel_rule_5:            '每日仅限一次..系统每日00:00-11:00关闭',
    ufa_wheel_rule_6:            '仅统计11:00-23:59时段的投注记录',
    ufa_wheel_rule_7:            '（亏损越多，越有机会赢得大奖）',
    ufa_wheel_warning:           '如发现故意对冲或跨多个用户刷奖金，将立即没收资金，绝不退款！',
    ufa_start_wheel_cta:         '开始转动转盘，点击这里！',
    ufa_checkin_rule_1:          '当日首存至少100泰铢（才能签到）',
    ufa_checkin_rule_2:          '当日至少有1笔投注记录',
    ufa_checkin_rule_3:          '每日仅限一次..系统每日00:00-23:00关闭',
    ufa_checkin_rule_4:          '投注记录于每日23:00后重置',
    ufa_checkin_rule_5:          '每日赠送，系统重置后可领取',
    ufa_checkin_rule_6:          '余额不得低于100泰铢',
    ufa_checkin_rule_7:          '签到后须完成奖金4倍流水方可提款',
    ufa_start_checkin_cta:       '开始签到，点击这里！',
    ufa_customer_reviews:        '客户评价',
    ufa_real_reviews:            '来自真实客户的评价',
    ufa_total:                   '共',
    ufa_reviews_unit:            '条评价',
    ufa_loading_reviews:         '正在加载评价...',
    ufa_no_reviews:              '暂无评价',
    ufa_no_comment:              '暂无评论',
    ufa_rank_subtitle:           '累积积分以获得特别 Rank 奖励',
    ufa_current_rank:            '当前 Rank',
    ufa_accumulated_points:      '累积积分',
    ufa_login_to_view_rank:      '请登录以查看并领取您的 Rank',
    ufa_points_up:              '积分及以上',
    ufa_get_bonus:               '领取奖金',
    ufa_claimed:                 '已领取',
    ufa_claim:                   '领取',
    ufa_not_reached:             '未达成',
    ufa_no_rank_data:            '系统中暂无 Rank 数据',
    ufa_betting_hub_tagline:     '全国最大的在线博彩中心',
  },
  ja: {
    ufa_casino_online:    'オンラインカジノ',
    ufa_football_online:  'スポーツベット',
    ufa_review_service:   'サービスレビュー',
    ufa_make_income:      '収入を得る',
    ufa_contact_us:       'お問い合わせ',
    ufa_login_member:     '会員ログイン',
    ufa_login_with_line:  'LINEでログイン',
    ufa_phone_label:      '電話番号',
    ufa_phone_placeholder:'電話',
    ufa_phone_placeholder_full: '電話番号を入力',
    ufa_password_placeholder:   'パスワードを入力',
    ufa_alert:            'お知らせ',
    ufa_login_before_action: 'お取引の前にログインしてください',

    ufa_create_deposit_title:    '入金作成',
    ufa_create_deposit_subtitle: 'チャネルを選択し、入金する金額を入力してください',
    ufa_deposit_channel:         '入金チャネル',
    ufa_bank_account:            '銀行口座',
    ufa_confirm_amount:          '金額を確認',
    ufa_cannot_create_deposit:   '入金を作成できません',
    ufa_confirm_topup:           'チャージを確認',
    ufa_cancel_qr_title:         'QRコードをキャンセル',
    ufa_cancel_qr_text:          'このQRコードの使用をキャンセルしますか？',
    ufa_complete_within_time:    '制限時間内にお取引を完了してください',
    ufa_amount_to_transfer:      '振込金額',
    ufa_deposit_timeout:         '入金がタイムアウトしました。新しく作成してください',
    ufa_account_copied_notice:   '口座番号をコピーしました。このページは入金期限まで開いたままになります',
    ufa_invalid_deposit_amount:  '入金額が無効です',
    ufa_pending_deposit_title:   '保留中の入金があります',
    ufa_old_order:               '元の注文',
    ufa_new_amount:              '新しい金額',
    ufa_cancel_old_create_new:   '元の注文をキャンセルして新規作成しますか？',
    ufa_create_new_order:        '新規注文を作成',
    ufa_use_old_order:           '元の注文を使用',
    ufa_deposit_closed_temp:     '入金一時停止中',
    ufa_gateway_closed_temp:     'Payment Gatewayは一時的に利用できません',
    ufa_no_payment_channel:      '支払いチャネルが見つかりません',
    ufa_no_link_or_qr:           'Payment GatewayのリンクまたはQRコードが見つかりません',
    ufa_no_bank_for_deposit:     '入金用の銀行口座が見つかりません',
    ufa_no_password:             'パスワードが入力されていません',
    ufa_password_more_6:         '6文字以上のパスワードを入力してください',
    ufa_fill_bank_info_6:        '銀行を選択するか、情報を入力してください',
    ufa_please_wait:             'お待ちください',
    ufa_promo_received:          'プロモーションを受け取りました。入金してください',
    ufa_promo_pending:           '保留中のプロモーションがあります',
    ufa_withdraw_bonus_line1:    '0クレジットのボーナスを引き出しますか？',
    ufa_withdraw_bonus_line2:    '以下からクレジットが返還されます（スロット：0 ライブカジノ：0 スポーツ：0）',
    ufa_confirm_withdraw_bonus:  'ボーナス出金を確認',
    ufa_your_member_id:          'あなたの会員IDは',
    ufa_hello:                   'こんにちは',
    ufa_your_credit_balance:     'あなたのクレジット残高',
    ufa_finance_history:         '取引履歴',
    ufa_rank_system:             'Rankシステム',
    ufa_open_card_fortune:       'ラッキーカード',
    ufa_spin_fortune_wheel:      'ラッキーホイールを回す',
    ufa_coupon:                  'クーポン',
    ufa_get_cashback_credit:     'キャッシュバッククレジットを受取',
    ufa_contact_staff:           'スタッフに連絡',
    ufa_play_entrance:           'UFA11で遊ぶ',
    ufa_backup:                  '予備',
    ufa_game_user:               'ゲームユーザー名',
    ufa_balance_remaining:       '利用可能残高',
    ufa_pwd_hint_1:              '*パスワードは8〜15文字である必要があります',
    ufa_pwd_hint_2:              '*パスワードは文字、数字、記号の組み合わせである必要があります',
    ufa_pwd_hint_3:              '*ログイン名、氏名をパスワードの一部に使用しないでください',
    ufa_play_now:                '今すぐプレイ',
    ufa_total_all:               '合計',
    ufa_processing:              '処理中',
    ufa_failed:                  '失敗',
    ufa_item:                    '項目',
    ufa_credit_refund:           'クレジット返還',
    ufa_update_pwd_ufa:          'システムのUFAパスワードを更新：',
    ufa_referral_link_label:     '紹介リンク',
    ufa_copy_link:               'リンクをコピー',
    ufa_referred_friends_count:  '紹介した友達の数',
    ufa_referral_credit_count:   '紹介クレジット',
    ufa_transfer_to_credit:      'クレジットへ振替',
    ufa_min_500_transfer:        '*クレジットへの振替は最低500バーツから',
    ufa_your_income:             'あなたの収入',
    ufa_share_via_line:          'LINEで紹介',
    ufa_share_via_messenger:     'Messengerで紹介',
    ufa_share_via_facebook:      'Facebookで紹介',
    ufa_cashback_amount:         'キャッシュバック額',
    ufa_min_15_transfer:         '*クレジットへの振替は最低15バーツから',
    ufa_balance_baht:            '利用可能残高（バーツ）',
    ufa_finish_deposit_first:    '新規作成の前に入金を完了してください',
    ufa_need_help_contact_line:  'サポートが必要ですか？LINE管理者に連絡：',
    ufa_continue_transaction:    '取引を続ける',
    ufa_create_new_deposit:      '新規入金を作成',
    ufa_deposit_registered_only: '登録済みの口座からのみ入金してください',
    ufa_deposit_problem_contact: '入金できない場合は24時間管理者に連絡してください、',
    ufa_view_deposit_history:    '入金履歴を見る',
    ufa_transfer_to_bank:        '銀行へ振替',
    ufa_amount:                  '金額',
    ufa_withdraw_placeholder:    '300または5000、カンマは不要！',
    ufa_notify_withdraw:         '出金',
    ufa_bank_maintenance_notice: '銀行システムは毎日23:00〜00:00および01:00〜02:00にメンテナンスを行います。通常どおり出金できますが、この時間帯の出金は遅れる場合があります。ご不便をおかけして申し訳ございません。',
    ufa_invite_earn:             '友達を紹介して稼ぐ',
    ufa_opencard_title:          'カードをめくって毎日500万バーツの賞金',
    ufa_join_conditions:         '参加条件',
    ufa_card_rule_1:             '当日の初回入金が100バーツ以上必要（ラッキーカードをプレイするため）',
    ufa_card_rule_2:             '当日に最低5回のプレイが必要',
    ufa_card_rule_3:             '1日1回のみ..システムは毎日00:00-11:00休止',
    ufa_card_rule_4:             'プレイ記録は毎日11:00後にリセット',
    ufa_card_rule_5:             '1日3,000ユーザー限定！システムリセット後に再度受取可能',
    ufa_card_rule_6:             '残高が100バーツ以上必要',
    ufa_card_rule_7:             'カードをめくった後、ボーナスの4倍を賭けてから出金可能',
    ufa_start_opencard_cta:      'カードめくりを始める、ここをクリック！',
    ufa_wheel_rule_1:            '当日1,000バーツの損失で、その日1回のスピン権を獲得',
    ufa_wheel_rule_2:            'ホイールボーナス受取後、ボーナスの4倍を賭けてから出金可能',
    ufa_wheel_rule_3:            '全ユーザーに毎日無制限で配布',
    ufa_wheel_rule_4:            '金1バーツを獲得した場合は直ちにチームに通知（チームが確認し賞品をお届けします）',
    ufa_wheel_rule_5:            '1日1回のみ..システムは毎日00:00-11:00休止',
    ufa_wheel_rule_6:            'プレイ記録は11:00-23:59のみカウント',
    ufa_wheel_rule_7:            '（損失が多いほど大きな賞品が当たりやすくなります）',
    ufa_wheel_warning:           '複数ユーザーでの意図的なヘッジやボーナス稼ぎが発覚した場合、直ちに資金を没収し返金は一切ありません！',
    ufa_start_wheel_cta:         'ホイールを回し始める、ここをクリック！',
    ufa_checkin_rule_1:          '当日の初回入金が100バーツ以上必要（チェックインするため）',
    ufa_checkin_rule_2:          '当日に最低1回のプレイが必要',
    ufa_checkin_rule_3:          '1日1回のみ..システムは毎日00:00-23:00休止',
    ufa_checkin_rule_4:          'プレイ記録は毎日23:00後にリセット',
    ufa_checkin_rule_5:          '毎日配布、システムリセット後に受取可能',
    ufa_checkin_rule_6:          '残高が100バーツ以上必要',
    ufa_checkin_rule_7:          'チェックイン後、ボーナスの4倍を賭けてから出金可能',
    ufa_start_checkin_cta:       'チェックインを始める、ここをクリック！',
    ufa_customer_reviews:        'お客様のレビュー',
    ufa_real_reviews:            '実際のお客様からのレビュー',
    ufa_total:                   '全',
    ufa_reviews_unit:            '件のレビュー',
    ufa_loading_reviews:         'レビューを読み込み中...',
    ufa_no_reviews:              'レビューはまだありません',
    ufa_no_comment:              'コメントなし',
    ufa_rank_subtitle:           'ポイントを貯めて特別なRank報酬を獲得',
    ufa_current_rank:            '現在のRank',
    ufa_accumulated_points:      '累積ポイント',
    ufa_login_to_view_rank:      'Rankを表示・受取するにはログインしてください',
    ufa_points_up:               'ポイント以上',
    ufa_get_bonus:               'ボーナス受取',
    ufa_claimed:                 '受取済み',
    ufa_claim:                   '受け取る',
    ufa_not_reached:             '未達成',
    ufa_no_rank_data:            'システムにRankデータがまだありません',
    ufa_betting_hub_tagline:     '国内最大のオンラインベッティングハブ',
  },
  my: {
    ufa_casino_online:    'အွန်လိုင်းကာစီနို',
    ufa_football_online:  'အားကစားလောင်းကြေး',
    ufa_review_service:   'ဝန်ဆောင်မှုသုံးသပ်ချက်',
    ufa_make_income:      'ဝင်ငွေရှာရန်',
    ufa_contact_us:       'ဆက်သွယ်ရန်',
    ufa_login_member:     'အသင်းဝင်ဝင်ရောက်ရန်',
    ufa_login_with_line:  'LINE ဖြင့်ဝင်ရောက်ရန်',
    ufa_phone_label:      'ဖုန်းနံပါတ်',
    ufa_phone_placeholder:'ဖုန်း',
    ufa_phone_placeholder_full: 'ဖုန်းနံပါတ်ထည့်ပါ',
    ufa_password_placeholder:   'စကားဝှက်ထည့်ပါ',
    ufa_alert:            'အသိပေးချက်',
    ufa_login_before_action: 'ငွေသွင်းမတိုင်မီ အကောင့်ဝင်ပါ',

    ufa_create_deposit_title:    'ငွေသွင်းမှု ဖန်တီးရန်',
    ufa_create_deposit_subtitle: 'လမ်းကြောင်းရွေးပြီး သွင်းမည့်ပမာဏ ထည့်ပါ',
    ufa_deposit_channel:         'ငွေသွင်းလမ်းကြောင်း',
    ufa_bank_account:            'ဘဏ်အကောင့်',
    ufa_confirm_amount:          'ပမာဏ အတည်ပြုရန်',
    ufa_cannot_create_deposit:   'ငွေသွင်းမှု ဖန်တီး၍မရပါ',
    ufa_confirm_topup:           'ငွေဖြည့်မှု အတည်ပြုရန်',
    ufa_cancel_qr_title:         'QR ကုဒ် ပယ်ဖျက်ရန်',
    ufa_cancel_qr_text:          'ဤ QR ကုဒ်ကို ပယ်ဖျက်လိုပါသလား?',
    ufa_complete_within_time:    'သတ်မှတ်ချိန်အတွင်း ပြီးအောင်လုပ်ပါ',
    ufa_amount_to_transfer:      'လွှဲရမည့်ပမာဏ',
    ufa_deposit_timeout:         'ငွေသွင်းမှု အချိန်ကုန်သွားပါပြီ၊ အသစ်ပြန်ဖန်တီးပါ',
    ufa_account_copied_notice:   'အကောင့်နံပါတ် ကူးပြီးပါပြီ၊ ဤစာမျက်နှာသည် ငွေသွင်းချိန်ကုန်သည်အထိ ဆက်ရှိနေမည်',
    ufa_invalid_deposit_amount:  'ငွေသွင်းပမာဏ မမှန်ပါ',
    ufa_pending_deposit_title:   'ဆိုင်းငံ့ထားသော ငွေသွင်းမှု ရှိပါသည်',
    ufa_old_order:               'အဟောင်းအော်ဒါ',
    ufa_new_amount:              'ပမာဏအသစ်',
    ufa_cancel_old_create_new:   'အဟောင်းအော်ဒါ ပယ်ဖျက်ပြီး အသစ်ဖန်တီးမလား?',
    ufa_create_new_order:        'အော်ဒါအသစ် ဖန်တီးရန်',
    ufa_use_old_order:           'အဟောင်းအော်ဒါ သုံးရန်',
    ufa_deposit_closed_temp:     'ငွေသွင်းမှု ယာယီ ပိတ်ထားသည်',
    ufa_gateway_closed_temp:     'Payment Gateway ယာယီ ဝန်ဆောင်မှု မရရှိနိုင်ပါ',
    ufa_no_payment_channel:      'ငွေပေးချေမှု လမ်းကြောင်း မတွေ့ပါ',
    ufa_no_link_or_qr:           'Payment Gateway အတွက် လင့်ခ် သို့ QR ကုဒ် မတွေ့ပါ',
    ufa_no_bank_for_deposit:     'ငွေသွင်းရန် ဘဏ်အကောင့် မတွေ့ပါ',
    ufa_no_password:             'စကားဝှက် မထည့်ရသေးပါ',
    ufa_password_more_6:         'အက္ခရာ ၆ လုံးထက်ပိုသော စကားဝှက် ထည့်ပါ',
    ufa_fill_bank_info_6:        'ဘဏ်ရွေးပါ သို့မဟုတ် အချက်အလက်ပြည့်စုံစွာ ဖြည့်ပါ',
    ufa_please_wait:             'ကျေးဇူးပြု၍ စောင့်ပါ',
    ufa_promo_received:          'ပရိုမိုးရှင်း ရရှိပါပြီ၊ ငွေဖြည့်ပါ',
    ufa_promo_pending:           'ဆိုင်းငံ့ထားသော ပရိုမိုးရှင်း ရှိပါသည်',
    ufa_withdraw_bonus_line1:    '၀ ခရက်ဒစ် ဘောနပ်စ်ကို ထုတ်လိုပါသလား?',
    ufa_withdraw_bonus_line2:    'အောက်ပါတို့မှ ခရက်ဒစ်ပြန်ရမည် (Slots: 0 Live Casino: 0 Sports: 0)',
    ufa_confirm_withdraw_bonus:  'ဘောနပ်စ်ထုတ်ယူမှု အတည်ပြုရန်',
    ufa_your_member_id:          'သင့်အသင်းဝင် ID မှာ',
    ufa_hello:                   'မင်္ဂလာပါ',
    ufa_your_credit_balance:     'သင့်ခရက်ဒစ် လက်ကျန်',
    ufa_finance_history:         'ငွေကြေးမှတ်တမ်း',
    ufa_rank_system:             'Rank စနစ်',
    ufa_open_card_fortune:       'ကံကောင်းကတ်ဖွင့်',
    ufa_spin_fortune_wheel:      'ကံကောင်းဘီးလှည့်ရန်',
    ufa_coupon:                  'ကူပွန်',
    ufa_get_cashback_credit:     'ပြန်အမ်းခရက်ဒစ် ရယူရန်',
    ufa_contact_staff:           'ဝန်ထမ်းကို ဆက်သွယ်ရန်',
    ufa_play_entrance:           'UFA11 ဝင်ကစားရန်',
    ufa_backup:                  'အရန်',
    ufa_game_user:               'ဂိမ်းအသုံးပြုသူအမည်',
    ufa_balance_remaining:       'ရရှိနိုင်သော လက်ကျန်',
    ufa_pwd_hint_1:              '*သင့်စကားဝှက်သည် အက္ခရာ ၈-၁၅ လုံး ရှိရမည်',
    ufa_pwd_hint_2:              '*သင့်စကားဝှက်တွင် စာလုံး၊ ဂဏန်းနှင့် သင်္ကေတများ ပါဝင်ရမည်',
    ufa_pwd_hint_3:              '*ဝင်ရောက်အမည်၊ အမည်ရင်းနှင့် မျိုးနွယ်အမည်ကို စကားဝှက်တွင် မသုံးပါနှင့်',
    ufa_play_now:                'ယခု ကစားရန်',
    ufa_total_all:               'စုစုပေါင်း',
    ufa_processing:              'ဆောင်ရွက်နေသည်',
    ufa_failed:                  'မအောင်မြင်ပါ',
    ufa_item:                    'အကြောင်းအရာ',
    ufa_credit_refund:           'ခရက်ဒစ်ပြန်အမ်း',
    ufa_update_pwd_ufa:          'စနစ်အတွင်း UFA စကားဝှက် အပ်ဒိတ်:',
    ufa_referral_link_label:     'မိတ်ဆက်လင့်ခ်',
    ufa_copy_link:               'လင့်ခ် ကူးရန်',
    ufa_referred_friends_count:  'မိတ်ဆက်ထားသော သူငယ်ချင်းအရေအတွက်',
    ufa_referral_credit_count:   'မိတ်ဆက်ခရက်ဒစ်',
    ufa_transfer_to_credit:      'ခရက်ဒစ်သို့ လွှဲရန်',
    ufa_min_500_transfer:        '*ခရက်ဒစ်သို့ လွှဲရန် အနည်းဆုံး ၅၀၀ ဘတ်',
    ufa_your_income:             'သင့်ဝင်ငွေ',
    ufa_share_via_line:          'LINE ဖြင့် မိတ်ဆက်ရန်',
    ufa_share_via_messenger:     'Messenger ဖြင့် မိတ်ဆက်ရန်',
    ufa_share_via_facebook:      'Facebook ဖြင့် မိတ်ဆက်ရန်',
    ufa_cashback_amount:         'ပြန်အမ်းငွေပမာဏ',
    ufa_min_15_transfer:         '*ခရက်ဒစ်သို့ လွှဲရန် အနည်းဆုံး ၁၅ ဘတ်',
    ufa_balance_baht:            'ရရှိနိုင်သော လက်ကျန် (ဘတ်)',
    ufa_finish_deposit_first:    'အသစ်မဖန်တီးမီ ငွေသွင်းမှု အရင်ပြီးအောင်လုပ်ပါ',
    ufa_need_help_contact_line:  'အကူအညီလိုပါသလား? LINE အက်ဒမင်ကို ဆက်သွယ်ပါ:',
    ufa_continue_transaction:    'ဆက်လုပ်ရန်',
    ufa_create_new_deposit:      'ငွေသွင်းမှုအသစ် ဖန်တီးရန်',
    ufa_deposit_registered_only: 'မှတ်ပုံတင်ထားသော အကောင့်ဖြင့်သာ ငွေသွင်းပါ',
    ufa_deposit_problem_contact: 'ငွေသွင်း၍မရပါက ၂၄ နာရီ အက်ဒမင်ကို ဆက်သွယ်ပါ',
    ufa_view_deposit_history:    'ငွေသွင်းမှတ်တမ်း ကြည့်ရန်',
    ufa_transfer_to_bank:        'ဘဏ်သို့ လွှဲရန်',
    ufa_amount:                  'ပမာဏ',
    ufa_withdraw_placeholder:    '၃၀၀ သို့ ၅၀၀၀၊ ကော်မာ မထည့်ပါနှင့်!',
    ufa_notify_withdraw:         'ငွေထုတ်ရန်',
    ufa_bank_maintenance_notice: 'ဘဏ်စနစ်သည် နေ့စဉ် ၂၃:၀၀-၀၀:၀၀ နှင့် ၀၁:၀၀-၀၂:၀၀ တွင် ပြုပြင်ထိန်းသိမ်းမှု ပြုလုပ်သည်။ ပုံမှန်အတိုင်း ငွေထုတ်နိုင်သေးသော်လည်း ဤအချိန်များတွင် ငွေထုတ်မှု နှောင့်နှေးနိုင်သည်။ အဆင်မပြေမှုအတွက် တောင်းပန်ပါသည်။',
    ufa_invite_earn:             'သူငယ်ချင်းမိတ်ဆက်ပြီး ဝင်ငွေရှာရန်',
    ufa_opencard_title:          'ကတ်ဖွင့်ပြီး နေ့စဉ် ၅,၀၀၀,၀၀၀ ဘတ် ဆုရယူပါ',
    ufa_join_conditions:         'ပါဝင်ရန် စည်းကမ်းချက်များ',
    ufa_card_rule_1:             'ယနေ့ ပထမငွေသွင်း အနည်းဆုံး ၁၀၀ ဘတ် ရှိရမည် (ကံကောင်းကတ် ကစားရန်)',
    ufa_card_rule_2:             'ယနေ့ အနည်းဆုံး ကစားမှု ၅ ကြိမ် ရှိရမည်',
    ufa_card_rule_3:             'တစ်နေ့ တစ်ကြိမ်သာ..စနစ်ကို နေ့စဉ် ၀၀:၀၀-၁၁:၀၀ ပိတ်သည်',
    ufa_card_rule_4:             'ကစားမှတ်တမ်းကို နေ့စဉ် ၁၁:၀၀ နောက်ပိုင်း ပြန်စသည်',
    ufa_card_rule_5:             'တစ်နေ့ ၃,၀၀၀ ဦးသာ! စနစ်ပြန်စပြီးနောက် ထပ်ရနိုင်သည်',
    ufa_card_rule_6:             'လက်ကျန် ၁၀၀ ဘတ်အောက် မရှိရ',
    ufa_card_rule_7:             'ကတ်ဖွင့်ပြီးနောက် ဘောနပ်စ်၏ ၄ ဆ လည်ပတ်မှ ငွေထုတ်နိုင်သည်',
    ufa_start_opencard_cta:      'ကတ်ဖွင့်စတင်ရန် ဤနေရာကို နှိပ်ပါ!',
    ufa_wheel_rule_1:            'ယနေ့ ရှုံးငွေ ၁,၀၀၀ ဘတ် ရှိမှ ထိုနေ့အတွက် ၁ ကြိမ် လှည့်ခွင့်ရမည်',
    ufa_wheel_rule_2:            'ဘီးဘောနပ်စ်ရရှိပါက ဘောနပ်စ်၏ ၄ ဆ လည်ပတ်မှ ငွေထုတ်နိုင်သည်',
    ufa_wheel_rule_3:            'အသုံးပြုသူအားလုံးကို နေ့စဉ် အကန့်အသတ်မရှိ ပေးသည်',
    ufa_wheel_rule_4:            'ရွှေ ၁ ဘတ် ရရှိပါက အဖွဲ့ကို ချက်ချင်းအကြောင်းကြားပါ (အဖွဲ့မှ စစ်ဆေးပြီး ဆုပို့ပေးမည်)',
    ufa_wheel_rule_5:            'တစ်နေ့ တစ်ကြိမ်သာ..စနစ်ကို နေ့စဉ် ၀၀:၀၀-၁၁:၀၀ ပိတ်သည်',
    ufa_wheel_rule_6:            'ကစားမှတ်တမ်းကို ၁၁:၀၀-၂၃:၅၉ သာ ရေတွက်သည်',
    ufa_wheel_rule_7:            '(ရှုံးငွေများလေ ဆုကြီးရနိုင်ခြေ များလေ)',
    ufa_wheel_warning:           'အသုံးပြုသူ ၁ ဦးထက်ပို၍ တမင်တကာ ဆန့်ကျင်လောင်းခြင်း သို့ ဘောနပ်စ်စုခြင်း တွေ့ရှိပါက ငွေကို ချက်ချင်းသိမ်းမည်၊ ပြန်အမ်းမည်မဟုတ်ပါ!',
    ufa_start_wheel_cta:         'ဘီးလှည့်စတင်ရန် ဤနေရာကို နှိပ်ပါ!',
    ufa_checkin_rule_1:          'ယနေ့ ပထမငွေသွင်း အနည်းဆုံး ၁၀၀ ဘတ် ရှိရမည် (ချက်အင်လုပ်ရန်)',
    ufa_checkin_rule_2:          'ယနေ့ အနည်းဆုံး ကစားမှု ၁ ကြိမ် ရှိရမည်',
    ufa_checkin_rule_3:          'တစ်နေ့ တစ်ကြိမ်သာ..စနစ်ကို နေ့စဉ် ၀၀:၀၀-၂၃:၀၀ ပိတ်သည်',
    ufa_checkin_rule_4:          'ကစားမှတ်တမ်းကို နေ့စဉ် ၂၃:၀၀ နောက်ပိုင်း ပြန်စသည်',
    ufa_checkin_rule_5:          'နေ့စဉ်ပေးသည်၊ စနစ်ပြန်စပြီးနောက် ရနိုင်သည်',
    ufa_checkin_rule_6:          'လက်ကျန် ၁၀၀ ဘတ်အောက် မရှိရ',
    ufa_checkin_rule_7:          'ချက်အင်ပြီးနောက် ဘောနပ်စ်၏ ၄ ဆ လည်ပတ်မှ ငွေထုတ်နိုင်သည်',
    ufa_start_checkin_cta:       'ချက်အင်စတင်ရန် ဤနေရာကို နှိပ်ပါ!',
    ufa_customer_reviews:        'ဖောက်သည် သုံးသပ်ချက်များ',
    ufa_real_reviews:            'အစစ်အမှန် ဖောက်သည်များမှ သုံးသပ်ချက်',
    ufa_total:                   'စုစုပေါင်း',
    ufa_reviews_unit:            'သုံးသပ်ချက်',
    ufa_loading_reviews:         'သုံးသပ်ချက်များ ဖွင့်နေသည်...',
    ufa_no_reviews:              'သုံးသပ်ချက် မရှိသေးပါ',
    ufa_no_comment:              'မှတ်ချက် မရှိပါ',
    ufa_rank_subtitle:           'အမှတ်စုဆောင်းပြီး အထူး Rank ဆုများ ရယူပါ',
    ufa_current_rank:            'လက်ရှိ Rank',
    ufa_accumulated_points:      'စုဆောင်းအမှတ်',
    ufa_login_to_view_rank:      'သင့် Rank ကြည့်ရှု၍ ရယူရန် အကောင့်ဝင်ပါ',
    ufa_points_up:               'အမှတ် နှင့်အထက်',
    ufa_get_bonus:               'ဘောနပ်စ် ရယူရန်',
    ufa_claimed:                 'ရယူပြီးပြီ',
    ufa_claim:                   'ရယူရန်',
    ufa_not_reached:             'မရောက်သေးပါ',
    ufa_no_rank_data:            'စနစ်တွင် Rank ဒေတာ မရှိသေးပါ',
    ufa_betting_hub_tagline:     'နိုင်ငံ၏ အကြီးဆုံး အွန်လိုင်းလောင်းကစား စင်တာ',
  },
  lo: {
    ufa_casino_online:    'ຄາສິໂນອອນລາຍ',
    ufa_football_online:  'ແທງບານອອນລາຍ',
    ufa_review_service:   'ຣີວິວການບໍລິການ',
    ufa_make_income:      'ສ້າງລາຍໄດ້',
    ufa_contact_us:       'ຕິດຕໍ່ພວກເຮົາ',
    ufa_login_member:     'ເຂົ້າສູ່ລະບົບສະມາຊິກ',
    ufa_login_with_line:  'ເຂົ້າສູ່ລະບົບດ້ວຍ LINE',
    ufa_phone_label:      'ເບີໂທລະສັບ',
    ufa_phone_placeholder:'ເບີໂທ',
    ufa_phone_placeholder_full: 'ປ້ອນເບີໂທລະສັບ',
    ufa_password_placeholder:   'ປ້ອນລະຫັດຜ່ານ',
    ufa_alert:            'ແຈ້ງເຕືອນ',
    ufa_login_before_action: 'ກະລຸນາເຂົ້າສູ່ລະບົບກ່ອນເຮັດລາຍການ',

    ufa_create_deposit_title:    'ສ້າງລາຍການຝາກ',
    ufa_create_deposit_subtitle: 'ເລືອກຊ່ອງທາງ ແລະ ລະບຸຈຳນວນເງິນທີ່ຕ້ອງການຝາກ',
    ufa_deposit_channel:         'ຊ່ອງທາງຝາກ',
    ufa_bank_account:            'ບັນຊີທະນາຄານ',
    ufa_confirm_amount:          'ຢືນຢັນຈຳນວນເງິນ',
    ufa_cannot_create_deposit:   'ບໍ່ສາມາດສ້າງລາຍການຝາກໄດ້',
    ufa_confirm_topup:           'ຢືນຢັນການເຕີມເງິນ',
    ufa_cancel_qr_title:         'ຍົກເລີກ QR code',
    ufa_cancel_qr_text:          'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ QR code ນີ້ບໍ?',
    ufa_complete_within_time:    'ກະລຸນາເຮັດລາຍການພາຍໃນເວລາ',
    ufa_amount_to_transfer:      'ຍອດເງິນທີ່ຕ້ອງໂອນ',
    ufa_deposit_timeout:         'ລາຍການຝາກໝົດເວລາແລ້ວ ກະລຸນາສ້າງລາຍການໃໝ່',
    ufa_account_copied_notice:   'ສຳເນົາເລກບັນຊີແລ້ວ ໜ້ານີ້ຈະຄ້າງໄວ້ຈົນກວ່າລາຍການຝາກຈະໝົດເວລາ',
    ufa_invalid_deposit_amount:  'ຍອດຝາກບໍ່ຖືກຕ້ອງ',
    ufa_pending_deposit_title:   'ມີລາຍການຝາກຄ້າງຢູ່',
    ufa_old_order:               'ລາຍການເດີມ',
    ufa_new_amount:              'ຍອດໃໝ່',
    ufa_cancel_old_create_new:   'ຕ້ອງການຍົກເລີກລາຍການເດີມ ແລ້ວສ້າງລາຍການໃໝ່ບໍ?',
    ufa_create_new_order:        'ສ້າງລາຍການໃໝ່',
    ufa_use_old_order:           'ໃຊ້ລາຍການເດີມ',
    ufa_deposit_closed_temp:     'ປິດຮັບຝາກຊົ່ວຄາວ',
    ufa_gateway_closed_temp:     'ຊ່ອງທາງ Payment Gateway ປິດໃຫ້ບໍລິການຊົ່ວຄາວ',
    ufa_no_payment_channel:      'ບໍ່ພົບຊ່ອງທາງຊຳລະເງິນ',
    ufa_no_link_or_qr:           'ບໍ່ພົບລິ້ງ ຫຼື QR Code ສຳລັບ Payment Gateway',
    ufa_no_bank_for_deposit:     'ບໍ່ພົບບັນຊີທະນາຄານສຳລັບເຮັດລາຍການຝາກ',
    ufa_no_password:             'ທ່ານບໍ່ໄດ້ໃສ່ລະຫັດຜ່ານ',
    ufa_password_more_6:         'ກະລຸນາໃສ່ລະຫັດຜ່ານຫຼາຍກວ່າ 6 ຕົວ',
    ufa_fill_bank_info_6:        'ກະລຸນາເລືອກທະນາຄານ ຫຼື ໃສ່ຂໍ້ມູນໃຫ້ຄົບຖ້ວນ',
    ufa_please_wait:             'ກະລຸນາລໍຖ້າ',
    ufa_promo_received:          'ຮັບໂປຣໂມຊັ່ນຮຽບຮ້ອຍ ກະລຸນາເຕີມເງິນ',
    ufa_promo_pending:           'ທ່ານມີໂປຣໂມຊັ່ນຄ້າງຢູ່',
    ufa_withdraw_bonus_line1:    'ຕ້ອງການຖອນໂບນັດຈຳນວນ 0 ເຄຣດິດ ແມ່ນບໍ?',
    ufa_withdraw_bonus_line2:    'ທ່ານຈະໄດ້ຮັບເຄຣດິດຄືນຈາກ (ສະລັອດ: 0 ຄາສິໂນສົດ: 0 ກິລາ: 0)',
    ufa_confirm_withdraw_bonus:  'ຢືນຢັນການຖອນໂບນັດ',
    ufa_your_member_id:          'ລະຫັດສະມາຊິກຂອງທ່ານແມ່ນ',
    ufa_hello:                   'ສະບາຍດີ',
    ufa_your_credit_balance:     'ຍອດເຄຣດິດຂອງທ່ານ',
    ufa_finance_history:         'ປະຫວັດການເງິນ',
    ufa_rank_system:             'ລະບົບ Rank',
    ufa_open_card_fortune:       'ເປີດໄພ່ສ່ຽງໂຊກ',
    ufa_spin_fortune_wheel:      'ໝູນກົງລໍ້ສ່ຽງໂຊກ',
    ufa_coupon:                  'ຄູປ໋ອງ',
    ufa_get_cashback_credit:     'ຮັບເຄຣດິດເງິນຄືນ',
    ufa_contact_staff:           'ຕິດຕໍ່ພະນັກງານ',
    ufa_play_entrance:           'ທາງເຂົ້າຫຼິ້ນ UFA11',
    ufa_backup:                  'ສຳຮອງ',
    ufa_game_user:               'User ເຂົ້າເກມ',
    ufa_balance_remaining:       'ຍອດເງິນຄົງເຫຼືອ',
    ufa_pwd_hint_1:              '*ລະຫັດຜ່ານຂອງທ່ານຕ້ອງປະກອບດ້ວຍຕົວອັກສອນ 8-15 ຕົວ',
    ufa_pwd_hint_2:              '*ລະຫັດຜ່ານຂອງທ່ານຕ້ອງມີການປະສົມຂອງຕົວອັກສອນ ຕົວເລກ ແລະ ສັນຍາລັກ',
    ufa_pwd_hint_3:              '*ຫ້າມໃຊ້ຊື່ເຂົ້າລະບົບ ຊື່ຈິງ ແລະ ນາມສະກຸນເປັນສ່ວນໜຶ່ງຂອງລະຫັດຜ່ານ',
    ufa_play_now:                'ຫຼິ້ນດຽວນີ້',
    ufa_total_all:               'ລວມທັງໝົດ',
    ufa_processing:              'ກຳລັງດຳເນີນການ',
    ufa_failed:                  'ບໍ່ສຳເລັດ',
    ufa_item:                    'ລາຍການ',
    ufa_credit_refund:           'ຄືນເຄຣດິດ',
    ufa_update_pwd_ufa:          'ອັບເດດ Password UFA ໃນລະບົບ:',
    ufa_referral_link_label:     'Link ແນະນຳ',
    ufa_copy_link:               'ສຳເນົາ link',
    ufa_referred_friends_count:  'ຈຳນວນໝູ່ທີ່ແນະນຳ',
    ufa_referral_credit_count:   'ຈຳນວນເຄຣດິດແນະນຳ',
    ufa_transfer_to_credit:      'ໂອນເງິນເຂົ້າເຄຣດິດ',
    ufa_min_500_transfer:        '*ຍອດຂັ້ນຕ່ຳ 500 ບາດ ຈຶ່ງຈະໂອນເຂົ້າເຄຣດິດໄດ້',
    ufa_your_income:             'ລາຍໄດ້ຂອງທ່ານ',
    ufa_share_via_line:          'ແນະນຳຜ່ານ LINE',
    ufa_share_via_messenger:     'ແນະນຳຜ່ານ Messenger',
    ufa_share_via_facebook:      'ແນະນຳຜ່ານ Facebook',
    ufa_cashback_amount:         'ຈຳນວນເງິນຄືນ',
    ufa_min_15_transfer:         '*ຍອດຂັ້ນຕ່ຳ 15 ບາດ ຈຶ່ງຈະໂອນເຂົ້າເຄຣດິດໄດ້',
    ufa_balance_baht:            'ຍອດເງິນຄົງເຫຼືອ (ບາດ)',
    ufa_finish_deposit_first:    'ກະລຸນາເຮັດລາຍການຝາກໃຫ້ສຳເລັດກ່ອນສ້າງລາຍການໃໝ່',
    ufa_need_help_contact_line:  'ຫາກຕ້ອງການຄວາມຊ່ວຍເຫຼືອ ຕິດຕໍ່ແອັດມິນ LINE:',
    ufa_continue_transaction:    'ເຮັດລາຍການຕໍ່',
    ufa_create_new_deposit:      'ສ້າງລາຍການຝາກໃໝ່',
    ufa_deposit_registered_only: 'ກະລຸນາຝາກດ້ວຍບັນຊີທີ່ລົງທະບຽນໄວ້ເທົ່ານັ້ນ',
    ufa_deposit_problem_contact: 'ຫາກບໍ່ສາມາດເຮັດລາຍການຝາກໄດ້ ຕິດຕໍ່ແອັດມິນໄດ້ຕະຫຼອດ 24 ຊົ່ວໂມງ ທີ່',
    ufa_view_deposit_history:    'ເບິ່ງປະຫວັດການຝາກ',
    ufa_transfer_to_bank:        'ໂອນເຂົ້າທະນາຄານ',
    ufa_amount:                  'ຈຳນວນເງິນ',
    ufa_withdraw_placeholder:    '300 ຫຼື 5000 ບໍ່ຕ້ອງໃສ່ , (ຈຸດ)!',
    ufa_notify_withdraw:         'ແຈ້ງຖອນເງິນ',
    ufa_bank_maintenance_notice: 'ລະບົບທະນາຄານຈະປິດປັບປຸງປະຈຳວັນໃນຊ່ວງເວລາ 23.00-00.00 ແລະ 01.00-02.00. ລູກຄ້າຍັງສາມາດຖອນເງິນໄດ້ປົກກະຕິ ແຕ່ຍອດຖອນໃນຊ່ວງເວລາດັ່ງກ່າວອາດຈະຊ້າກວ່າປົກກະຕິ ຂໍອະໄພໃນຄວາມບໍ່ສະດວກ.',
    ufa_invite_earn:             'ແນະນຳໝູ່ສ້າງລາຍໄດ້',
    ufa_opencard_title:          'ເປີດໄພ່ຮັບເງິນແຈກວັນລະ 5,000,000 ບາດ',
    ufa_join_conditions:         'ເງື່ອນໄຂການຮ່ວມສະໜຸກ',
    ufa_card_rule_1:             'ຕ້ອງມີຍອດຝາກທຳອິດຂອງວັນຂັ້ນຕ່ຳ 100 ບາດ (ຈຶ່ງຈະຫຼິ້ນໄພ່ສ່ຽງໂຊກໄດ້)',
    ufa_card_rule_2:             'ຕ້ອງມີລາຍການຫຼິ້ນຂອງວັນນັ້ນແລ້ວຢ່າງໜ້ອຍ 5 ລາຍການ',
    ufa_card_rule_3:             'ຫຼິ້ນໄດ້ວັນລະຄັ້ງເທົ່ານັ້ນ..ປິດລະບົບ 00.00-11.00 ຂອງທຸກວັນ',
    ufa_card_rule_4:             'ລາຍການຫຼິ້ນ..ຣີ ຫຼັງ 11.00 ຂອງທຸກວັນ',
    ufa_card_rule_5:             'ແຈກວັນລະ 3,000 user ເທົ່ານັ້ນ! ຮັບໄດ້ອີກຫຼັງເວລາຣີລະບົບ',
    ufa_card_rule_6:             'ຕ້ອງມີເງິນຄົງເຫຼືອບໍ່ຕ່ຳກວ່າ 100 ບາດ',
    ufa_card_rule_7:             'ຫຼັງຈາກເປີດໄພ່ແລ້ວຈະຕ້ອງເຮັດເທີນ 4 ເທົ່າຂອງໂບນັດທີ່ເປີດໄດ້ ຈຶ່ງຈະຖອນເງິນໄດ້',
    ufa_start_opencard_cta:      'ເລີ່ມເປີດໄພ່ສ່ຽງໂຊກ ຄລິກບ່ອນນີ້!',
    ufa_wheel_rule_1:            'ຕ້ອງມີຍອດເສຍຂອງວັນນັ້ນ 1,000 ບາດ ຈຶ່ງຈະຮັບສິດໝູນກົງລໍ້ໃນວັນນັ້ນໄດ້ 1 ຄັ້ງ',
    ufa_wheel_rule_2:            'ເມື່ອຮັບໂບນັດເກມກົງລໍ້ ຈະຕ້ອງເຮັດ turnover 4 ເທົ່າຂອງໂບນັດທີ່ເປີດໄດ້ ຈຶ່ງຈະຖອນເງິນໄດ້',
    ufa_wheel_rule_3:            'ແຈກທຸກ user ບໍ່ອັ້ນ ທຸກວັນ ບໍ່ມີຈຳກັດ',
    ufa_wheel_rule_4:            'ທ່ານທີ່ໄດ້ຮັບຄຳ 1 ບາດ ໃຫ້ແຈ້ງທີມງານທັນທີ (ທີມງານຈະສອບຖາມ ແລະ ສົ່ງລາງວັນໃຫ້ເຖິງທີ່)',
    ufa_wheel_rule_5:            'ຫຼິ້ນໄດ້ວັນລະຄັ້ງເທົ່ານັ້ນ..ປິດລະບົບ 00.00-11.00 ຂອງທຸກວັນ',
    ufa_wheel_rule_6:            'ນັບລາຍການຫຼິ້ນຊ່ວງ 11.00-23.59 ເທົ່ານັ້ນ',
    ufa_wheel_rule_7:            '(ຍິ່ງມີຍອດເສຍຫຼາຍກໍ່ຍິ່ງລຸ້ນຮັບລາງວັນໃຫຍ່ໄດ້ຫຼາຍຂຶ້ນ)',
    ufa_wheel_warning:           'ຫາກພົບເຫັນຕັ້ງໃຈແທງສວນ ຫຼື ປັ້ມໂບນັດ..ຫຼາຍກວ່າ 1 user ຈະຍຶດເງິນທັນທີບໍ່ມີຄືນເງິນ ເດັດຂາດ!',
    ufa_start_wheel_cta:         'ເລີ່ມໝູນກົງລໍ້ສ່ຽງໂຊກ ຄລິກບ່ອນນີ້!',
    ufa_checkin_rule_1:          'ຕ້ອງມີຍອດຝາກທຳອິດຂອງວັນຂັ້ນຕ່ຳ 100 ບາດ (ຈຶ່ງຈະເຊັກອິນໄດ້)',
    ufa_checkin_rule_2:          'ຕ້ອງມີລາຍການຫຼິ້ນຂອງວັນນັ້ນແລ້ວຢ່າງໜ້ອຍ 1 ລາຍການ',
    ufa_checkin_rule_3:          'ຫຼິ້ນໄດ້ວັນລະຄັ້ງເທົ່ານັ້ນ..ປິດລະບົບ 00.00-23.00 ຂອງທຸກວັນ',
    ufa_checkin_rule_4:          'ລາຍການຫຼິ້ນ..ຣີ ຫຼັງ 23.00 ຂອງທຸກວັນ',
    ufa_checkin_rule_5:          'ແຈກທຸກວັນ ຮັບໄດ້ຫຼັງເວລາຣີລະບົບ',
    ufa_checkin_rule_6:          'ຕ້ອງມີເງິນຄົງເຫຼືອບໍ່ຕ່ຳກວ່າ 100 ບາດ',
    ufa_checkin_rule_7:          'ຫຼັງຈາກເຊັກອິນແລ້ວຈະຕ້ອງເຮັດເທີນ 4 ເທົ່າຂອງໂບນັດທີ່ເປີດໄດ້ ຈຶ່ງຈະຖອນເງິນໄດ້',
    ufa_start_checkin_cta:       'ເລີ່ມເຊັກອິນ ຄລິກບ່ອນນີ້!',
    ufa_customer_reviews:        'ຣີວິວຄຳຊົມຈາກລູກຄ້າ',
    ufa_real_reviews:            'ຣີວິວຈາກລູກຄ້າຈິງ',
    ufa_total:                   'ທັງໝົດ',
    ufa_reviews_unit:            'ຣີວິວ',
    ufa_loading_reviews:         'ກຳລັງໂຫຼດຣີວິວ...',
    ufa_no_reviews:              'ຍັງບໍ່ມີຣີວິວ',
    ufa_no_comment:              'ບໍ່ມີຄຳເຫັນ',
    ufa_rank_subtitle:           'ສະສົມຄະແນນເພື່ອຮັບລາງວັນ Rank ພິເສດ',
    ufa_current_rank:            'Rank ປັດຈຸບັນ',
    ufa_accumulated_points:      'ຄະແນນສະສົມ',
    ufa_login_to_view_rank:      'ກະລຸນາເຂົ້າສູ່ລະບົບເພື່ອເບິ່ງ ແລະ ຮັບ Rank ຂອງທ່ານ',
    ufa_points_up:               'ແຕ້ມຂຶ້ນໄປ',
    ufa_get_bonus:               'ຮັບໂບນັດ',
    ufa_claimed:                 'ຮັບແລ້ວ',
    ufa_claim:                   'ກົດຮັບ',
    ufa_not_reached:             'ຍັງບໍ່ເຖິງ',
    ufa_no_rank_data:            'ຍັງບໍ່ມີຂໍ້ມູນ Rank ໃນລະບົບ',
    ufa_betting_hub_tagline:     'ສູນລວມເວັບພະນັນອອນລາຍ ທີ່ໃຫຍ່ທີ່ສຸດໃນປະເທດ',
  },
};

Object.keys(ext).forEach((l) => {
  translations[l] = Object.assign({}, translations[l], ext[l]);
});

export default ext;